import { NgModule } from '@angular/core';
import { AbsolutePathPipe } from './absolute-path.pipe';
@NgModule({
    imports: [],
    declarations: [
        AbsolutePathPipe,
    ],
    exports: [
        AbsolutePathPipe,
    ]
})

export class AbsolutePathModule{}
